module.exports = __webpack_public_path__ + "resources/images/ovchipkaart-a5d270da0cdc662f3fcc0f09d3cab50b-cache.jpg";